export default __webpack_public_path__ + "static/media/AA Posters_2_Web Size.1b9d084d.jpg";